import {styled} from "styled-components";

export const IonCardFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 0 16px 16px;
`;
